var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close-button",class:_vm.noBorder ? '' : 'border',style:(_vm.customStyle),on:{"click":_vm.click}},[_c('img',{attrs:{"src":require('pinnacle-lib/assets/icon/x-icon.svg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }